// @flow

import ShippingInformation from './ShippingInformation'

export default ShippingInformation
